import React from "react";
import { Select, Icon, InputNumber, message } from "antd";
import API_URL from "../../../common/url.js";
import $ from "../../../common/AjaxRequest.js";
import TableC from "../../basicElement/TableC.js";
import Update from "./Update.js";

class Content extends React.Component {
    state = {
        searchParams: {},
        loading: false,
        data: [],
    }

    componentDidMount() {
        const { siteStartType } = this.props;
        this.loadData(siteStartType);
    }

    componentWillReceiveProps(nextProps) {
        const { siteStartType } = nextProps;
        if (siteStartType !== this.props.siteStartType) {
            this.loadData(siteStartType)
        }
    }

    loadData = (siteStartType) => {
        if (!siteStartType) return
        const options = {
            method: 'POST',
            url: API_URL.evaluate.querySiteStartFeeRateListWithLevel,
            data: {
                siteStartType,
            },
            dataType: 'json',
            doneResult: res => {
                const { list } = res;
                this.setState({ 
                    loading: false,
                    data: this.getDataSource(list),
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [
        {
            title: "序号",
            key: "sortNum",
            dataIndex: "sortNum",
            width: 100,
            render: (text, record) => this.renderUserRow(text, record.rowSpan)
        },
        {
            title: "岗位",
            key: "postCode",
            dataIndex: "postCode",
            width: 100,
            render: (text, record) => this.renderUserRow(text, record.rowSpan)
        },
        {
            title: "启动费用占比（%）",
            key: "startFeeRate",
            dataIndex: "startFeeRate",
            width: 100,
            onCellClick: (record) => { this.handleEditChange(record) },
            render: (text, record, index) => this.renderUserRow(this.renderText(text, record, 'startFeeRate', index), record.rowSpan)
        },
        {
            title: "工作内容",
            key: "workContent",
            dataIndex: "workContent",
            width: 240,
            render: (text) => this.renderUserRow(text, 1)
        },
        {
            title: "工作内容-费用占比（%）",
            key: "workContentRate",
            dataIndex: "workContentRate",
            width: 120,
            render: (text) => this.renderUserRow(`${text}%`, 1)
        },
        {
            title: "操作",
            key: "operate",
            dataIndex: "operate",
            width: 120,
            // render: (text, record) => this.renderUserRow(<a onClick={() => this.update(record)}>修改</a>, record.rowSpan)
            render: () => '-'
        },
    ];

    update = (record) => {
        const { postCode } = record;
        const { data } = this.state;
        const recordData = data.filter(el => el.postCode === postCode);
        this.updateRef.show(recordData);
    }

    renderUserRow = (value, rowSpan) => {
        const obj = {
            children: value ? value : '-',
            props: {
                rowSpan,
            },
        };
        return obj
    }

    handleEditChange = record => {
        const { data } = this.state;
        const { isEdit } = record;
        let num = 0;
        data.filter(a => a.rowSpan).map(b => {
            num = num + b.startFeeRate;
        });
        if (num != 100) {
            return message.warning('请确保各启动费用占比之和=100%！');
        } else { 
            data.map(el => {
                el.isEdit = !isEdit;
            })
        }
        if (isEdit) {
            this.submit();
        }
        this.setState({ data });
    }

    submit = () => {
        const { siteStartType } = this.props;
        const { data } = this.state;
        let obj = {};
        data.filter(a => a.rowSpan).map(b => {
            const {postCode, startFeeRate} = b;
            obj[`datas[${postCode}]`] = startFeeRate;
        })
        const options = {
            method: 'POST',
            url: API_URL.evaluate.saveClinicalSiteStartFeeRate,
            data: {
                siteStartType,
                ...obj,
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.loadData();
            },
            errorResult: () => {
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    renderUserRow = (value, rowSpan) => {
        const obj = {
            children: value ? value : '-',
            props: {
                rowSpan,
            },
        };
        return obj
    }

    renderText = (text, record, key, index) => {
        const { isEdit } = record;
        return isEdit ? 
            <div style={{ display: 'inline-block'}} onClick={e => e.stopPropagation()}>
                <InputNumber step={0.01} value={text} min={0} precision={2} onChange={value => this.handleNumberChange(value, key, index)} />
            </div>
            : `${text}%`
    }

    handleNumberChange = (value, key, index) => {
        const { data } = this.state;
        data[index][key] = value;
        this.setState({ data });
    }

    getDataSource = (data = []) =>{
        const newData = [];
        data.forEach((el, index) => {
            const { postCode, startFeeRate, childList } = el;
            (childList || []).forEach((childData, childIndex) => {
                const {
                    workContent, 
                    workContentRate,
                    workContentCode,
                } = childData;
                newData.push(
                    {
                        sortNum: index + 1,
                        postCode,
                        startFeeRate,
                        workContent, 
                        workContentRate,
                        workContentCode,
                        isEdit: false,
                        rowSpan: childIndex ? 0 : childList.length,
                    }
                )
            })
        })
        newData.map((el, index) => {
            newData[index].childIndex = index;
        })
        return newData
    }

    render() {
        const { loading, data } = this.state;
        const { siteStartType } = this.props;
        return(
            <div>
                <TableC
                    loading={loading}
                    scrollY={500}
                    columns={this.getColumns()}
                    data={data}
                />
                <Update ref={el => this.updateRef = el} loadData={this.loadData} siteStartType={siteStartType}/>
            </div>
        )
    }
}

export default Content;




// WEBPACK FOOTER //
// ./src/components/businessOffer/siteStartServiceFeePercent/Content.js